export default {
    index: {
        home: 'Home',
        meetingCountdown: 'Countdown to Conference Start',
        importantEvents: 'Important Dates',
        contactUs: 'Contact Us',
        Day: 'Day',
        Hour: 'Hour',
        Minute: 'Minute',
        Second: 'Second',
        Organizer: 'Organizer'
    }
}